import React from "react";
import moment from "moment-timezone";

import Icon from "~/src/components/icon";
import {
  GridCardWrapper,
  StyledMaskContainer,
  Div,
  IconWrapper,
} from "./unavailable-grid-card.styles";

const UnavailableGridCard = ({
  unavailability: { startsAt, endsAt, reason },
  onClick,
}) => {
  const reasonLabels = {
    unwell: "Feeling unwell",
    personal: "Personal reason",
    holiday: "On holiday",
    ratherNotSay: "Rather not say",
    workStudy: "Work / study commitments",
  };

  let timeString = ``;

  if (startsAt !== null) {
    if (endsAt !== null) {
      timeString = `${moment(startsAt).format("HH:mm")} - ${moment(endsAt).format("HH:mm")}`;
    } else {
      timeString = `after ${moment(startsAt).format("HH:mm")}`;
    }
  } else if (endsAt !== null) {
    timeString = `until ${moment(endsAt).format("HH:mm")}`;
  } else {
    timeString = "all day";
  }

  return (
    <GridCardWrapper onClick={onClick}>
      <StyledMaskContainer>
        <Div fontSize="12px" textTransform="capitalize">
          Unavailable
        </Div>
        <Div fontSize="12px" fontWeight="500">
          {timeString}
        </Div>
        <Div fontSize="12px" width="auto">
          {reasonLabels[reason] || "N/A"}
        </Div>
      </StyledMaskContainer>
      <IconWrapper>
        <Icon
          name={Icon.names.PLUS}
          color={Icon.colors.SILVER}
          size={Icon.sizes.SMALL}
        />
      </IconWrapper>
    </GridCardWrapper>
  );
};

export default UnavailableGridCard;
